import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Bornholm (1-42)
import bornholm1 from '../images/bornholm1.jpeg';
import bornholm2 from '../images/bornholm2.jpeg';
import bornholm3 from '../images/bornholm3.jpeg';
import bornholm4 from '../images/bornholm4.jpeg';
import bornholm5 from '../images/bornholm5.jpeg';
import bornholm6 from '../images/bornholm6.jpeg';
import bornholm7 from '../images/bornholm7.jpeg';
import bornholm8 from '../images/bornholm8.jpeg';
import bornholm9 from '../images/bornholm9.jpeg';
import bornholm10 from '../images/bornholm10.jpeg';
import bornholm11 from '../images/bornholm11.jpeg';
import bornholm12 from '../images/bornholm12.jpeg';
import bornholm13 from '../images/bornholm13.jpeg';
import bornholm14 from '../images/bornholm14.jpeg';
import bornholm15 from '../images/bornholm15.jpeg';
import bornholm16 from '../images/bornholm16.jpeg';
import bornholm17 from '../images/bornholm17.jpeg';
import bornholm18 from '../images/bornholm18.jpeg';
import bornholm19 from '../images/bornholm19.jpeg';
import bornholm20 from '../images/bornholm20.jpeg';
import bornholm21 from '../images/bornholm21.jpeg';
import bornholm22 from '../images/bornholm22.jpeg';
import bornholm23 from '../images/bornholm23.jpeg';
import bornholm24 from '../images/bornholm24.jpeg';
import bornholm25 from '../images/bornholm25.jpeg';
import bornholm26 from '../images/bornholm26.jpeg';
import bornholm27 from '../images/bornholm27.jpeg';
import bornholm28 from '../images/bornholm28.jpeg';
import bornholm29 from '../images/bornholm29.jpeg';
import bornholm30 from '../images/bornholm30.jpeg';
import bornholm31 from '../images/bornholm31.jpeg';
import bornholm32 from '../images/bornholm32.jpeg';
import bornholm33 from '../images/bornholm33.jpeg';
import bornholm34 from '../images/bornholm34.jpeg';
import bornholm35 from '../images/bornholm35.jpeg';
import bornholm36 from '../images/bornholm36.jpeg';
import bornholm37 from '../images/bornholm37.jpeg';
import bornholm38 from '../images/bornholm38.jpeg';
import bornholm39 from '../images/bornholm39.jpeg';
import bornholm40 from '../images/bornholm40.jpeg';
import bornholm41 from '../images/bornholm41.jpeg';
import bornholm42 from '../images/bornholm42.jpeg';

function Bornholm() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    bornholm1, bornholm2, bornholm3, bornholm4, bornholm5, bornholm6, bornholm7, bornholm8, bornholm9, bornholm10,
    bornholm11, bornholm12, bornholm13, bornholm14, bornholm15, bornholm16, bornholm17, bornholm18, bornholm19, bornholm20,
    bornholm21, bornholm22, bornholm23, bornholm24, bornholm25, bornholm26, bornholm27, bornholm28, bornholm29, bornholm30,
    bornholm31, bornholm32, bornholm33, bornholm34, bornholm35, bornholm36, bornholm37, bornholm38, bornholm39, bornholm40,
    bornholm41, bornholm42
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>Bornholm 2021</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Bornholm ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Bornholm;